import { useTranslation } from "react-i18next";

import { Button } from "src/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";
import { MappedStakeholder } from "src/core/constants/folder";
import { useDeleteStakeholder } from "src/core/hooks/folder/useDeleteStakeholder";

type DeleteStakeholderModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  stakeholder?: MappedStakeholder;
  onSuccess?: () => void;
};

export const DeleteStakeholderModal = ({
  open,
  setOpen,
  stakeholder,
  onSuccess,
}: DeleteStakeholderModalProps) => {
  const { t } = useTranslation();

  const { corporationId, handleDelete, loading } = useDeleteStakeholder({
    stakeholder,
    onSuccess: () => {
      onSuccess?.();
      setOpen(false);
    },
  });

  if (!stakeholder || !corporationId) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent hideCloseButton onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>{t("modal.deleteStakeholder.title")}</DialogTitle>
          <DialogDescription className="sr-only">
            {t("modal.deleteStakeholder.description")}
          </DialogDescription>
        </DialogHeader>

        <DialogDescription style={{ whiteSpace: "pre-line" }}>
          {t("modal.deleteStakeholder.description", {
            firstName: stakeholder.firstName || "",
            lastName: stakeholder.lastName || "",
            role: stakeholder.roles.join(", ") || "",
          })}
        </DialogDescription>

        <DialogFooter>
          <Button variant="default" className="ml-[20px]" onClick={handleDelete} loading={loading}>
            {t("modal.deleteStakeholder.submit")}
          </Button>
          <Button
            variant="link"
            onClick={(event) => {
              event.preventDefault();
              setOpen(false);
            }}
            disabled={loading}
          >
            {t("global.form.cancel")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
